import { Component, OnInit } from '@angular/core';
import { JobDetailsService } from '../../service/job-details.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
})
export class JobsComponent implements OnInit {
    currentLang = '';
    companyName: string;
    companyId: string;
    jobs: any;
    updateDate: any;
    deadline: any;
    viewLink: any;
    jobId: number;

    constructor(private jobDetailsService: JobDetailsService,
                private router: Router,
                public route: ActivatedRoute,
                private titleService: Title,
                private translateService: TranslateService) {

        this.companyId = localStorage.getItem('companyId');
        if (this.companyId === '1') {
            this.companyName = 'Ameriabank CJSC';
            this.getJobs();
        } else if (this.companyId === '2') {
            this.companyName = 'Ameria Legal and Tax Advisory';
            this.getJobs();
        }
    }

    ngOnInit() {
      // this.getPageUpdateDate();
      this.translateService.get('jobsPageBrowserName').subscribe(name => {
        this.titleService.setTitle(name);
      });

      this.updateDate = new Date();
    }

    getJobs() {
      this.currentLang = localStorage.getItem('lang');
      this.jobDetailsService.getJobs(this.currentLang).subscribe((result) => {
          if (result.length) {
            this.jobs = result;
            this.jobs.map((job) => {
              if (job.ApplicationDeadline) {
                const originalDeadlineSplit = job.ApplicationDeadline.split('T');
                const originalDay = originalDeadlineSplit[0].split('-');
                const dayToView = originalDay[2] + '/' + originalDay[1] + '/' + originalDay[0];
                this.deadline = dayToView;
                this.viewLink = job.ViewLink;
                this.jobId = job.Id;
                job.deadlineToView = this.deadline;
              }
            });
          }
      });
    }

  /* RequisitionType: "Generation A" */

    redirectPage(job){
      if(job.RequisitionType === 'Generation A'){
        if(localStorage.getItem('lang') === 'am'){
          window.open(' https://generationa-arm.ameriabank.am/', '_blank');
        } else {
          window.open(' https://generationa-en.ameriabank.am/', '_blank');
        }
      }
    }

    getPageUpdateDate() {
      this.jobDetailsService.getPageUpdateDate(this.companyId).subscribe((result) => {
        if (result) {
          const originalDate = result;
          // @ts-ignore
          const originalDateSplit = originalDate.split('T');
          const originalDay = originalDateSplit[0].split('-');
          const originalHours = originalDateSplit[1].split(':');
          const dayToView = originalDay[2] + '/' + originalDay[1] + '/' + originalDay[0];
          const hoursToview = originalHours[0] + ':' + originalHours[1];
          this.updateDate = dayToView + ',' + ' ' + hoursToview;
        }
      });
  }

}
